import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ImportWizard from "../components/ImportParticipants/ImportWizard";
import ProgramEnrollmentImport from "../components/ImportParticipants/ProgramEnrollmentImport/ProgramEnrollmentImport";
import Button from '../components/UI/Button';
import { participantDataImportEnabled, programEnrollmentImportEnabled } from '../utils/features';

type ImportType = {
    id: 'participant' | 'programEnrollment';
    path: string;
    title: string;
    description: string;
    buttonText: string;
    enabled: boolean;
};

const ImportParticipants = () => {
    useEffect(() => {
        document.title = "Data Import";
    }, []);
    const location = useLocation();
    const navigate = useNavigate();
    const configuredImportTypes: ImportType[] = [
        {
            id: 'participant',
            path: '/import/participants',
            title: 'Participant Data Import',
            description: 'Import participant profiles, household members, and associated information.',
            buttonText: 'Import Participants',
            enabled: participantDataImportEnabled
        },
        {
            id: 'programEnrollment',
            path: '/import/program-enrollment',
            title: 'Program Enrollment Import',
            description: 'Import current or historical program enrollment dates for existing participants.',
            buttonText: 'Import Program Enrollments',
            enabled: programEnrollmentImportEnabled
        }
    ];
    const availableImportTypes = configuredImportTypes.filter(importType => importType.enabled);
    const hasImportType = (id: ImportType['id']) => availableImportTypes.some(importType => importType.id === id);
    const returnToSelection = availableImportTypes.length > 1 ? () => navigate('/import') : undefined;

    if (location.pathname === '/import/participants') {
        return hasImportType('participant') ? <ImportWizard onBackToImportTypes={returnToSelection} /> : <Navigate to="/import" replace />;
    }

    if (location.pathname === '/import/program-enrollment') {
        return hasImportType('programEnrollment') ? <ProgramEnrollmentImport onBackToImportTypes={returnToSelection} /> : <Navigate to="/import" replace />;
    }

    if (availableImportTypes.length === 1) {
        return <Navigate to={availableImportTypes[0].path} replace />;
    }

    return <div className="row justify-content-center"><div className="column"><div className="section"><h1 className="form-header data-import-selection-header">Data Import</h1><p className="data-import-selection-note">Choose one of the import options below to continue.</p><div className="row">{availableImportTypes.map(importType => <div className="column" key={importType.id}><div className="card"><div className="card-body"><h2>{importType.title}</h2><p>{importType.description}</p><Button id={`select-${importType.id}-import`} text={importType.buttonText} onClick={() => navigate(importType.path)} /></div></div></div>)}</div></div></div></div>;
};

export default ImportParticipants;
